//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProductBaseView from './Variants/BaseSmall'
import ProductBaseViewSimpler from './Variants/Simpler'
import ProductSetView from './Variants/SimpleSet'
// import ProductSaleView from './Variants/Sale'

export default {
  name: 'SimpleCardUi',
  components: {
    ProductBaseView,
    ProductBaseViewSimpler,
    // ProductSaleView,
    ProductSetView,
  },
  props: {
    isSempler: {
      default: false,
    },
    product: {
      default: () => { },
    },
    load: {},
    canRemove: {},
  },

  computed: {
    isSet() {
      return this.product.base.element.props.set
    },
    productProps() {
      const { relations, base, price } = this.product
      return {
        load: this.load,
        product: base,
        relations,
        price,
        disabled: this.$attrs.disabled,
        canRemove: this.canRemove,
      }
    },
  },
}
